import { LanguageCode } from "../termsAndConditions/termsAndConditionTypes"

export const ConfigureLanguage = {
    en: LanguageCode.EN,
    da: LanguageCode.DA,
}
export type Template = Readonly<{
    id: number
    name: string
    languageCode: LanguageCode
    status: TemplateStatus
}>

export enum TemplateStatus {
    IN_USE = "IN_USE",
    UNUSED = "UNUSED",
}

export type TemplateDetails = Readonly<{
    id: number
    supplier: {
        id: number
        name: string
    }
    name: string
    languageCode: LanguageCode
    status: TemplateStatus
    layout: {
        theme: {
            id: number
            previewImage: {
                url: string
            }
        }
    }
    content: {
        centerContent: CenterContent
        merchantLogo: MerchantLogo
        shortcuts: Shortcuts
    }
}>
type LabelText = Readonly<{
    label: string
}>
export type CenterContent = Readonly<{
    purchaseButton: LabelText
    subtitle: LabelText
    title: LabelText
}>
type MerchantLogo = Readonly<{
    uid: string
    url: string
}>
type Shortcuts = Readonly<{
    helpCenter: boolean
    downloadApp: boolean
}>

export type CreateUpdateTemplate = Readonly<{
    name: string
    languageCode: LanguageCode
    layout: {
        theme: {
            id: number
        }
    }
    content: {
        centerContent: CenterContent
        merchantLogo: {
            uid: string
        }
        shortcuts: Shortcuts
    }
}>

export type CreateUpdateTemplateFormValues = Readonly<{
    name: string
    languageCode: LanguageCode
    layout: {
        theme: {
            id: number | undefined
        }
    }
    content: {
        centerContent: CenterContent
        shortcuts: Shortcuts
        merchantLogo?: MerchantLogo
    }
}>

export type Theme = Readonly<{
    id: number
    previewImage: {
        url: string
    }
}>

export type GeneralSettings = Readonly<{
    localization: {
        defaultLanguage: LanguageCode
    }
    receipt: {
        posPrintingMode: PosPrintingMode
    }
    interaction: {
        returnToHomeScreenDelay: number
        returnToHomeAfterPurchase: number
    }
}>

export type UpdateGeneralSettings = Readonly<{
    localization: {
        defaultLanguage: LanguageCode
    }
    receipt: {
        posPrintingMode: PosPrintingMode
    }
    interaction?: {
        returnToHomeScreenDelay: number
        returnToHomeAfterPurchase: number
    }
}>

export enum PosPrintingMode {
    QR_ONLY = "QR_ONLY",
    AUTO = "AUTO",
    MANUALLY = "MANUALLY",
}
